import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const kinexaiotConfig: TSPConfig = {
  key: 'kinexaiot',
  name: 'KinexaIOT',
  imageName: 'KinexaIOT',
  category: TSPCategory.CUSTOM,
  helpText: (
    <>
      <p>To connect your KinexaIOT account, you'll need your DOT Number.</p>
      <p>
        Please contact your KinexaIOT administrator if you need help finding
        this information.
      </p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'DOT Number',
          name: 'dotnumber',
          type: 'number',
          required: true,
        },
      ]}
    />
  ),
};

export default kinexaiotConfig;
